/*!
 * SummaryView - Vue résumé / fiches descriptives pour IconsView
 */

import CardView from './CardView';

export default class SummaryView extends CardView {
    constructor(plugin) {
        super(plugin, 'summary');
    }

    renderIcon(data, container, subdir, path) {
        const myself = this.plugin;
        if (data.type === 'root') return true;

        const summaryConf = myself.getViewConfig('summary') || {};
        const summaryIconSize = myself.getViewIconSize('summary');
        myself.viewThumbsHeight = summaryIconSize;
        myself.viewThumbsWidth = summaryIconSize;
        myself.viewItemWidthRatio = summaryConf.ratio || 4;
        myself.viewItemWidthMin = summaryConf.minWidth || 300;
        myself.viewItemWidthMax = summaryConf.maxWidth || 800;
        myself.viewItemThumbsMode = true;

        const currentType = this.getTypes(data);
        const currentClassAll = this.buildItemClasses(data, currentType, (data.class || data.cls || ''));

        const codeSubtext = [];
        const codeActions = [];
        const summaryFields = myself.getViewFields('summary');

        if (data && summaryFields && summaryFields.length) {
            $.each(summaryFields, (indexView, column) => {
                if (typeof column === 'object' && column.type === 'action') {
                    if (data.actions && !data.special) {
                        const action = data.actions[column.name];
                        if (action) {
                            const buttonIcon = myself.renderIconImage('small', action.icon);
                            const columnData = '<span class="iv__item__action">'
                                    + '<button class="action--default action" title="' + action.label + '" data-action="' + column.name + '">' + buttonIcon + '</button>'
                                    + '</span>';
                            codeActions.push(columnData);
                        }
                    }
                } else {
                    let codeStart = '';
                    let codeEnd = '';
                    if (typeof column === 'object') {
                        if (column.tag) {
                            codeStart = '<' + column.tag + '>';
                            codeEnd = '</' + column.tag + '>';
                        }
                        column = column.data || column.name || column.field;
                    }
                    const rawVal = (data.data && data.data[column] !== undefined) ? data.data[column] : data[column];
                    if (rawVal !== undefined && rawVal !== null) {
                        codeSubtext.push(myself.renderSubdata(rawVal, codeStart, codeEnd, data));
                    }
                }
            });
        } else {
            const fallbackTableCols = myself.getViewColumns('table');
            if (fallbackTableCols && fallbackTableCols.length) {
                $.each(fallbackTableCols, (indexView, column) => {
                    if (column.type === 'action') {
                        if (data.actions && !data.special) {
                            const action = data.actions[column.name];
                            if (action) {
                                const buttonIcon = myself.renderIconImage('small', action.icon);
                                const columnData = '<span class="iv__item__action">'
                                        + '<button class="action--default action" title="' + action.label + '" data-action="' + column.name + '">' + buttonIcon + '</button>'
                                        + '</span>';
                                codeActions.push(columnData);
                            }
                        }
                    } else if (column.type === 'input') {
                        myself.reloadInput = true;
                        if (data.input) {
                            const input = data.input[column.name];
                            if (input) {
                                const columnData = '<div class="iv__item__input" data-property="' + column.name + '">'
                                        + input
                                        + '</div>';
                                codeSubtext.push(columnData);
                            }
                        }
                    } else if (data.data && data.data[column.name]) {
                        const columnData = '<div class="iv__item__detail">' + data.data[column.name] + '</div>';
                        codeSubtext.push(columnData);
                    }
                });
            }
        }

        const thumbsWidth = summaryIconSize;
        const thumbsHeight = summaryIconSize;

        const code = '<div class="' + currentClassAll + '"><div class="iv__item__frame"><span class="iv__item__link"><span class="iv__item__wrap"><span class="iv__item__image" style="width:' + thumbsWidth + 'px; height:' + thumbsHeight + 'px;">' + myself.renderIconImage(summaryIconSize, data.icon, data, 'img') + `</span></span>
                <label class="iv__item__label" style="width:` + thumbsWidth + 'px; max-height:' + thumbsWidth + `px;">
                <span class="iv__item__name titre">` + data.label + `</span>
                ` + ((codeSubtext.length > 0) ? '<span class="iv__item__data infos">' + codeSubtext.join('') + '</span>' : '') + `
                ` + ((codeActions.length > 0) ? '<span class="iv__item__actions">' + codeActions.join('') + '</span>' : '') + `
                </label></span></div></div>`;

        const currentIcon = $(code);
        const currentIconReact = currentIcon.find('.iv__item__image');

        container.append(currentIcon);
        this.attachItemEvents(currentIcon, currentIconReact, data, currentType, path);
        this.renderBadge(data, currentIcon);

        return currentIcon;
    }

    getZoomLimits() {
        return { enabled: true, min: 96, max: 208 };
    }
}
